/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlRiskHistoryLogType = {
    Fullscan: 'fullscan',
    Rescan: 'rescan',
    FalsePositiveRemoved: 'false_positive_removed',
    VulnerabilityResolved: 'vulnerability_resolved'
} as const;
export type ControlRiskHistoryLogType = typeof ControlRiskHistoryLogType[keyof typeof ControlRiskHistoryLogType];


export function ControlRiskHistoryLogTypeFromJSON(json: any): ControlRiskHistoryLogType {
    return ControlRiskHistoryLogTypeFromJSONTyped(json, false);
}

export function ControlRiskHistoryLogTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlRiskHistoryLogType {
    return json as ControlRiskHistoryLogType;
}

export function ControlRiskHistoryLogTypeToJSON(value?: ControlRiskHistoryLogType | null): any {
    return value as any;
}

